var map = {
	"./_template.yaml": 26,
	"./binaryAdd.yaml": 27,
	"./binaryIncrement.yaml": 28,
	"./binaryMult.yaml": 29,
	"./busyBeaver3.yaml": 30,
	"./busyBeaver4.yaml": 31,
	"./copy1s.yaml": 32,
	"./divisibleBy3.yaml": 33,
	"./divisibleBy3Base10.yaml": 34,
	"./lengthMult.yaml": 35,
	"./matchBinaryStrings.yaml": 36,
	"./matchThreeLengths.yaml": 37,
	"./palindrome.yaml": 38,
	"./powersOfTwo.yaml": 39,
	"./repeat01.yaml": 40,
	"./unaryMult.yaml": 41
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;



//////////////////
// WEBPACK FOOTER
// ./src/examples ./~/raw-loader!^\.\/.*\.yaml$
// module id = 44
// module chunks = 0